<form class="grid-container grid-3" [formGroup]="formGroup">
    <ui-form-field class="grid-row-1" [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.X_AXIS' | translate">
        <ui-select
            formControlName="measureCode"
            labelField="name"
            valueField="measureCode"
            [options]="availableMeasures"
            [required]="true"
            [disabled]="!availableMeasures.length || disabled"
        />
    </ui-form-field>

    @if (!formGroup.controls.limit.value) {
        <ui-toggle
            class="grid-row-1 toggle"
            formControlName="shouldZeroBeDisplayed"
            [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.SHOULD_ZERO_BE_DISPLAYED' | translate"
        />
    }

    <ui-form-field class="grid-row-2" [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.CATEGORIZATION' | translate">
        <ui-select
            formControlName="categorizationDimensionCode"
            labelField="name"
            valueField="dimensionCode"
            groupField="resourceTypeLabel"
            [options]="(segmentationDimensions$ | async) ?? []"
            [required]="true"
            [disabled]="!(segmentationDimensions$ | async)?.length || disabled"
        />
    </ui-form-field>

    @if (isMeasureSegmentable$ | async) {
        <ui-form-field class="grid-row-3" [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.SEGMENTATION' | translate">
            <ui-select
                formControlName="segmentationDimensionCode"
                labelField="name"
                valueField="dimensionCode"
                groupField="resourceTypeLabel"
                [options]="(segmentationDimensions$ | async) ?? []"
                [disabled]="!(segmentationDimensions$ | async)?.length || disabled"
                [clearable]="true"
            />
        </ui-form-field>
    }

    @if (formGroup.controls.categorizationDimensionCode.value && !formGroup.controls.segmentationDimensionCode.value) {
        <ui-form-field class="grid-row-4" [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.LIMIT' | translate">
            <input advizeoInput type="number" min="1" step="1" formControlName="limit" />
        </ui-form-field>
        <ui-toggle
            class="grid-row-4 toggle"
            formControlName="isSortReversed"
            [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.TOGGLE_REVERSE_SORT' | translate"
        />
    }
</form>
